import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface RedemptionTimerFieldProps {
  value: number; // minutes
  onChange: (minutes: number) => void;
}

/** Number + unit (minutes/hours) input for the post-redemption timer, stored in minutes. */
export function RedemptionTimerField({ value, onChange }: RedemptionTimerFieldProps) {
  const unit: "minutes" | "hours" = value % 60 === 0 && value >= 60 ? "hours" : "minutes";
  const displayValue = unit === "hours" ? value / 60 : value;

  const setValue = (n: number, u: "minutes" | "hours") => {
    const minutes = u === "hours" ? n * 60 : n;
    onChange(Math.max(5, Math.min(1440, minutes)));
  };

  return (
    <div className="flex items-center gap-2">
      <Input
        type="number"
        inputMode="numeric"
        min={1}
        className="h-11 w-20"
        value={displayValue}
        onChange={(e) => setValue(Number(e.target.value) || 1, unit)}
        aria-label="Time to redeem"
      />
      <Select value={unit} onValueChange={(u) => setValue(displayValue, u as "minutes" | "hours")}>
        <SelectTrigger className="h-11 w-32">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="minutes">Minutes</SelectItem>
          <SelectItem value="hours">Hours</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
